import { ComponentType, useState } from 'react';

import { Button, ButtonProps } from '@/components/form/baseInputs/Button';
import type { IconProps } from '@/components/icons/Upload01Icon';
import { Upload01Icon } from '@/components/icons/Upload01Icon';
import { EntityType } from '@/modules/entities/types/EntityType';

import { StandaloneDocumentUploaderModal } from '../../DocumentUploaderModal/StandaloneDocumentUploaderModal';

interface DocumentUploadButtonProps extends Partial<ButtonProps> {
  householdId: string;
  entityId?: string;
  entityType?: EntityType | undefined | null;
  onModalClose?: (documentId?: string) => void;
  additionalUploadDetails?: React.ReactNode;
  documentText?: string;
  icon?: ComponentType<IconProps>;
}

export function DocumentUploadButton({
  onModalClose,
  householdId,
  entityId,
  entityType,
  additionalUploadDetails,
  documentText = 'Upload document',
  icon: IconComponent = Upload01Icon,
  ...props
}: DocumentUploadButtonProps) {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);

  function handleModalClose(documentIds: string[]) {
    setUploadModalOpen(false);
    // Pass the first document ID for backward compatibility
    onModalClose?.(documentIds[0]);
  }

  return (
    <>
      <Button
        onClick={() => setUploadModalOpen(true)}
        variant="primary"
        size="sm"
        startIcon={IconComponent}
        {...props}
      >
        {documentText}
      </Button>
      <StandaloneDocumentUploaderModal
        householdId={householdId}
        entityId={entityId}
        entityType={entityType}
        uploadModalOpen={uploadModalOpen}
        onModalClose={handleModalClose}
        additionalDetails={additionalUploadDetails}
      />
    </>
  );
}
